import React from 'react';
import styled from 'styled-components';

// Fundo global para a página de privacidade
const PrivacyBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  background: linear-gradient(135deg, #0a192f 0%, #051937 50%, #000c24 100%);
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: radial-gradient(circle at 60% 10%, rgba(64, 128, 255, 0.07) 0%, transparent 60%),
      radial-gradient(circle at 20% 80%, rgba(0,255,255,0.05) 0%, transparent 70%);
    z-index: 1;
    pointer-events: none;
  }
`;

const Container = styled.div`
  max-width: 800px;
  margin: 5rem auto 3rem auto;
  padding: 2.5rem 2rem 3rem 2rem;
  background: rgba(10, 22, 40, 0.93);
  border-radius: 18px;
  box-shadow: 0 0 24px 0 rgba(0,255,255,0.06), 0 2px 32px 0 rgba(0,255,200,0.10);
  color: #e6faff;
  font-family: 'Inter', 'Roboto Mono', 'Fira Mono', monospace;
  font-size: 1.08rem;
  line-height: 1.7;
  letter-spacing: 0.01em;
  position: relative;
  z-index: 2;
  @media (max-width: 900px) {
    padding: 1.5rem 0.5rem 2rem 0.5rem;
    margin: 2rem 0.5rem 2rem 0.5rem;
  }
`;

const Title = styled.h1`
  background: linear-gradient(90deg, rgba(140,202,255,0.95) 0%, rgba(92,227,255,0.95) 45%, rgba(70,255,255,0.95) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 2rem;
  text-align: center;
  letter-spacing: 0.02em;
`;

const Subtitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 700;
  color: #00ffe6;
  margin-top: 2.5rem;
  margin-bottom: 0.8rem;
  letter-spacing: 0.01em;
`;

const PrivacyPolicy = () => (
  <>
    <PrivacyBg />
    <Container>
    <Title>Política de Privacidade</Title>
    <p>Esta Política de Privacidade descreve como a BIANCA coleta, usa e protege suas informações pessoais ao utilizar nossos serviços e plataforma.</p>

    <Subtitle>1. Coleta de Informações</Subtitle>
    <p>Coletamos informações fornecidas diretamente por você, como nome, telefone, e-mail e dados de uso da plataforma. Também coletamos dados de navegação, cookies e logs para melhorar sua experiência.</p>

    <Subtitle>2. Uso das Informações</Subtitle>
    <p>Utilizamos suas informações para:
      <ul>
        <li>Fornecer e aprimorar nossos serviços</li>
        <li>Personalizar sua experiência</li>
        <li>Entrar em contato para fins operacionais e de suporte</li>
        <li>Cumprir obrigações legais</li>
      </ul>
    </p>

    <Subtitle>3. Compartilhamento de Dados</Subtitle>
    <p>Seus dados não são vendidos. Podemos compartilhar informações com parceiros e provedores de serviço apenas para operação da plataforma, sempre seguindo padrões rígidos de segurança e confidencialidade.</p>

    <Subtitle>4. Segurança</Subtitle>
    <p>Adotamos medidas técnicas e organizacionais para proteger seus dados contra acesso não autorizado, alteração, divulgação ou destruição.</p>

    <Subtitle>5. Direitos do Usuário</Subtitle>
    <p>Você pode solicitar acesso, correção ou exclusão de seus dados pessoais a qualquer momento, entrando em contato pelo nosso canal oficial.</p>

    <Subtitle>6. Cookies</Subtitle>
    <p>Utilizamos cookies para melhorar funcionalidades e analisar o uso da plataforma. Você pode gerenciar suas preferências de cookies nas configurações do seu navegador.</p>

    <Subtitle>7. Alterações nesta Política</Subtitle>
    <p>Poderemos atualizar esta política periodicamente. Notificaremos sobre mudanças relevantes por meio dos nossos canais oficiais.</p>

    <Subtitle>8. Contato</Subtitle>
    <p>Em caso de dúvidas sobre esta Política de Privacidade, entre em contato pelo e-mail: <a href="mailto:joaoferrari@journeyagency.com.br" style={{color:'#00ffe6'}}>joaoferrari@journeyagency.com.br</a></p>
  </Container>
  </>
);

export default PrivacyPolicy;
